import { createContext, useReducer } from "react";

export const FoodFactContext = createContext();

export const foodFactReducer = (state, action) => {
    switch (action.type) {
        case 'SET_FOOD_FACT':
            return {
                foodFact: action.payload
            }
        case 'CREATE_FOOD_FACT':
            return {
                foodFact: [action.payload, ...state.foodFact]
            }
        case 'DELETE_FOOD_FACT':
            return {
                foodFact: state.foodFact.filter(a => a._id !== action.payload._id)
            }
        default:
            return state
    };
};

export const FoodFactContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(foodFactReducer, {
        foodFact: null
    });

    return (
        <FoodFactContext.Provider value={{ ...state, dispatch }}>
            {children}
        </FoodFactContext.Provider>
    );
};